/* istanbul ignore file */
import React from 'react';
import Promise from 'bluebird';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { AudienceAdgroupCreationWizard } from '@bingads-webui-campaign-legacy/audience-campaign/loader';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';
import PageContext from '@bingads-webui-static-legacy/page-context';
import eventDispatcher from '@bingads-webui-component-legacy/event-dispatcher/index';
import { withDelayedStyles } from '@bingads-webui-campaign-react/common-utils';
import { getAdgroupCreationAudienceStyle } from '../styles/adgroup-creation-audience-styles';
import { InjectWrapperWithHoC, getDelayedCreationStyles } from '../helper';
import VerticalLayout from '../template/steps-template.pug';
import HeaderTemplate from '../template/header-template.pug';

const ADGROUP_CREATION_AUDIENCE_LOADED_EVENT = 'ad_group_creation_view_loaded';
function AdGroupCreationAudience(props) {
  const {
    serverContext: {
      CurrentAccount: {
        CurrencyCode,
      },
      CurrentAccountInActive,
      Permissions: {
        IsReadOnlyUser,
      },
    },
    campaignContext: { currentCampaign },
    perfMarker,
    isVideo,
    isOpenCreatePanel,
    i18n,
  } = props;
  const isShoppingCampaign = _.result(_.take(currentCampaign.CampaignSettings), 'ProviderId');
  const AdGroupCreationAudiencePerfMarker = perfMarker.createChild('AdGroupCreationAudience');

  return (<InjectWrapperWithHoC
    {...props}
    InjectViewFactory={() => Promise.resolve(AudienceAdgroupCreationWizard)}
    InjectViewOption={{
      viewContext: {
        accountCurrencyCode: CurrencyCode,
        isReadOnlyUser: IsReadOnlyUser,
        CurrentAccountInActive,
        currentCampaign,
      },
      audienceCampaignType: isShoppingCampaign ? 'shopping' : '',
      perfMarker: AdGroupCreationAudiencePerfMarker,
      layout: VerticalLayout,
      headerTemplate: HeaderTemplate,
      isForVNext: true,
      isVideo,
      isOpenCreatePanel,
      newI18n: i18n,
      deps: {
        decimal,
        pageContext: PageContext,
      },
      serverContext: props.serverContext,
    }}
    callbackAfterRendered={() => _.defer(() => eventDispatcher.trigger(ADGROUP_CREATION_AUDIENCE_LOADED_EVENT))}
    styleScopeName="CampaignCreationAudience"
  />);
}

AdGroupCreationAudience.propTypes = {
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.shape({
      CurrencyCode: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  campaignContext: PropTypes.objectOf(PropTypes.any).isRequired,
  perfMarker: perfMarkerPropTypes.isRequired,
  isVideo: PropTypes.bool,
  isOpenCreatePanel: PropTypes.bool, // isOpenCreatePanel: see if the page is opened from the link in delivery status column
  decimal: PropTypes.shape({}).isRequired,
  PageContext: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }),
};

AdGroupCreationAudience.defaultProps = {
  isVideo: false,
  isOpenCreatePanel: false,
  i18n: {
    getString: text => text,
  },
};

export const StyledAdGroupCreationAudience =
  withDelayedStyles(AdGroupCreationAudience, getAdgroupCreationAudienceStyle, getDelayedCreationStyles, ADGROUP_CREATION_AUDIENCE_LOADED_EVENT);

